import { render, staticRenderFns } from "./PageAside.vue?vue&type=template&id=ff5cbff0&"
import script from "./PageAside.vue?vue&type=script&lang=js&"
export * from "./PageAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports